import { HookTextField, Text } from "@asayinc/component-library";
import { Box } from "@mui/material";
import { useWatch } from "react-hook-form";

interface IProps {
  isDisabled?: boolean;
  charLimit: number;
  companyName: string;
}

const WebinarFields = ({ isDisabled, charLimit, companyName }: IProps) => {
  // this inputs current value
  const webinarName = useWatch({
    name: "meta.webinarName",
  });

  return (
    <>
      <Text variant="subtitle1">Webinar name</Text>
      <Box width="100%">
        <HookTextField
          variant="outlined"
          outerLabel={`${companyName} ${webinarName || ""} Q&A`}
          id="webinarName"
          inputSize="small"
          showCharChount
          disabled={isDisabled}
          maxLength={charLimit}
          name="meta.webinarName"
          placeholder="e.g., Q1 2023 Investor Day"
          rules={{
            required: {
              value: true,
              message: "Webinar name is required.",
            },
          }}
          sx={{ width: "100%" }}
        />
      </Box>
    </>
  );
};

export default WebinarFields;
